import Vue from 'vue'

/**
 * Copy to clipboard the text passed
 * @param {String} text string to copy
 */
Vue.prototype.$clipboard = function (text) {
  const el = document.createElement('textarea')

  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

Vue.prototype.$clone = (obj) => JSON.parse(JSON.stringify(obj))
